import { Schema as S } from "effect";
export const Schema = S.Union(S.Literal("live"), S.Literal("test")).pipe(S.annotations({
    identifier: "@open-revenue/schema/stripe/Environment",
    description: "The environment of the Stripe API",
    examples: [
        "live",
        "test"
    ]
}));
export const make = (environment)=>S.decodeUnknown(Schema)(environment);
export const makeUnsafe = (environment)=>environment;
